import { api } from "@shared/lib/api";
import { AddBy, BackednResponse } from "@shared/lib/types";
import {
  IBucket,
  IBucketFacets,
  IBucketResponse,
  ICreateBucketRequest,
  IBuckRequest,
} from "@shared/lib/types/influencer";

export class BucketService {
  public static async createBucket(bucket: ICreateBucketRequest) {
    const newbucket ={
            category:bucket.bucketCategory,
            description:bucket.bucketDescription,
            name:bucket.bucketName
    }
    await api.post("bucket", {
      json: {
        ...newbucket,
      },
    });
  }
  public static async getBucketFacets() {
      const url = `bucket/facets`;
      const response = (await api
        .get(url)
        .json()) as BackednResponse<IBucketFacets>;
      return response;
  }
  public static async getBuckets(params:IBuckRequest){
    const {searchQuery,pageNo,limit,category,minInfluencerCount,categories} = params;
    const querryparams = new URLSearchParams();
    if (searchQuery) {
      querryparams.append("searchQuery", searchQuery);
    }
    if (pageNo) {
      querryparams.append("pageNo", pageNo.toString());
    }
    if (limit) {
      querryparams.append("limit", limit.toString());
    }
    if (category) {
      querryparams.append("category", category.join("$$"));
    }
    if (categories && categories.length>0) {
      querryparams.append("category", categories.join("$$"));
    }
    // if (minInfluencerCount) {
    //   querryparams.append("minInfluencerCount", minInfluencerCount.toString());
    // }
    const queryString = querryparams.toString();
    const url = `bucket${queryString ? `?${queryString}` : ""}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IBucketResponse>;
    return response;
  }


  public static async updateBucket(bucketId:string,bucket: ICreateBucketRequest) {
    const updatedbucket ={
            category:bucket.bucketCategory,
            description:bucket.bucketDescription,
            name:bucket.bucketName,
            bucketId:bucketId
    }
    await api.patch(`bucket`, {
      json: {
        ...updatedbucket,
      },
    });
  }

  public static async suggestInCampaign(creatorIds:string[]){
       const url = `bucket/suggest-in-campaign`;
       await api.post(url, {
        json: {
          creatorIds
        },
      });
  }

  public static async getbucketById(bucketId:string){
    const url = `bucket/${bucketId}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IBucket>;
      return response;
  }

  public static async addCreatorsToBuckets({
    bucketIds,
    addBy,
  }: {
    bucketIds: string[];
    addBy: AddBy[]
  }) {
    const url = "social-media/buckets";
    await api.post(url, {
      json: {
        bucketIds,
        addBy,
      },
    });
  }
}
